import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getLogsNiceenergie(fromDate, toDate) {
  return () => {
    return apiCaller
      .call(api.getLogsNiceenergie(fromDate, toDate))
      .then(result => {
        return result.data;
      })
      .catch(e => {
        Logger.log('dataActions: getLogsNiceenergie - ', e);
        throw e;
      });
  };
}
export { getLogsNiceenergie };



// WEBPACK FOOTER //
// ./environments/logging/data/LogsNiceenergie/actions.js